import { createTheme } from '@mui/material/styles';
import { createBreakpoints } from "@mui/system";

const breakpoints = createBreakpoints({});

export const themeResponsive = createTheme({

  palette: {
    //mode: 'dark',
    primary: {
      main: '#1976d2',
    },
  },

  typography: {

   vociMenu: {
      fontSize: 28,
      lineHeight: "40px",
      fontWeight: 600,
      // ___schermo pc
      [breakpoints.up("lg")]: {
        fontSize: 28,
        color: "green"
      },
      // ___schermo tablet
      [breakpoints.up("sm")]: {
        color: "red",
        fontSize: 18
      },
      // ___schermo tel
      [breakpoints.down("sm")]: {
        color: "blue",
        fontSize: 22
      },
    },

   titoloPagina: {
      fontSize: 30,
      lineHeight: "40px",
      fontWeight: 600,
      // ___schermo pc
      [breakpoints.up("lg")]: {
        fontFamily: 'Arial',
        fontWeight: 500,
        fontSize: 30,
      },
      // ___schermo tablet
      [breakpoints.up("sm")]: {
        fontFamily: 'Arial',
        fontWeight: 400,
        fontSize: 25
      },
      // ___schermo tel
      [breakpoints.down("sm")]: {
        fontFamily: 'Arial',
        fontWeight: 300,
        color: "blue",
        fontSize: 20
      },
    }    

  }

});

const responsiveWithH1_H6Theme = createTheme({

  palette: {
    mode: 'dark',
    primary: {
      main: '#1976d2',
    },
  },

  typography: {

   h1: {
      fontSize: 28,
      lineHeight: "40px",
      fontWeight: 600,
      // 2. (Optional) Use your breakpoints created above to customize your
      // responseive font size at the global level
      [breakpoints.down("md")]: {
        color: "red",
        fontSize: 18
      },
      [breakpoints.up("md")]: {
        color: "blue",
        fontSize: 22
      },
      [breakpoints.up("lg")]: {
        fontSize: 28,
        color: "green"
      }
    },

    h2: {
      fontSize: 6
    },

    button: {
      fontSize: 20,
      lineHeight: "28px",
      fontWeight: 600,
      [breakpoints.down("md")]: {
        color: "red",
        fontSize: 10
      },
      [breakpoints.up("md")]: {
        color: "blue",
        fontSize: 20
      },
      [breakpoints.up("lg")]: {
        fontSize: 30,
        color: "green"
      }
    }

  }
});

